import { reactive } from "vue"
import { useContractStore } from "@/stores/contract"
import { defineStore } from "pinia"
import { IOptionList } from "@/interface"
import { getContractStore } from "@/helpers/storeHelpers"

export const useListsStore = defineStore('lists', () => {
    const selectMsisdn = reactive({
        msisdn: { label: '', value : "0"} as IOptionList
    })

    function updateSelectedMsisdn(option: IOptionList) {
        selectMsisdn.msisdn = option
    }

    function updateStoreMsisdn(option: IOptionList) {
        const newId = parseInt(option.value)
        const contractStore = getContractStore()
        if (contractStore && contractStore.currentId !== newId) {
            contractStore.selectContract(newId)
        }
    }

    function $reset() {
        selectMsisdn.msisdn = { label: '', value : "0"}
    }

    return {
        selectMsisdn,
        updateStoreMsisdn,
        updateSelectedMsisdn,
        $reset
    }
}, {
    persist: true
})

export type ListStore = ReturnType<typeof useListsStore>